// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Catalogs_wrapperComponent__XB5AP","image":"Catalogs_image__yUs8H","name":"Catalogs_name__46+Vp"};